/* eslint-disable fp/no-mutation */
window.getCookie = function getCookie(name) {
  const regEx = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regEx)
  if (match) return match[2]
  return null
}
